import React, { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import { DataContext } from '../data/DataContext';
import { DataContextType } from '../data_types/interfaces';

interface Props {
    children: React.ReactNode;
}

const AdminChecker = ({ children }: Props) => {
    const navigate = useNavigate();
    const context = useContext<DataContextType | undefined>(DataContext);
    const { isAdmin, isCreator, loading } = context || {};

    useEffect(() => {
        if (!loading) {
            console.log(`AdminChecker: isAdmin is ${isAdmin}, isCreator is ${isCreator}`);
            // TODO: Add logic to check if user is admin or creator, and redirect to /not-authorized if not
            if (isAdmin !== true && isCreator !== true) {
                navigate('/not-authorized');
            }
        }
    }, [navigate, isAdmin, isCreator, loading]);

    if (loading) {
        return <div>Loading...</div>;
    }

    return <>{children}</>;
};

export default AdminChecker;
